import styled from "styled-components";

export const ToggleSwitchButton = styled.button`
  --w: 40px;
  --h: 25px;
  --p: 2px;
  --b: 2px;
  width: var(--w);
  height: var(--h);
  padding: var(--p);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  background-color: ${({ isActive, inactiveColor, activeColor }) => (isActive ? activeColor : inactiveColor)};
  border: 2px solid #fff;
  border-radius: 999px;
  cursor: pointer;
  --ball: calc(var(--h) - var(--p) * 2 - var(--b) * 2);
  --travel: calc(var(--w) - var(--p) * 2 - var(--b) * 2 - var(--ball));
`;
export const Ball = styled.div`
  width: var(--ball);
  height: var(--ball);
  border-radius: 50%;
  background: #fff;
  flex: 0 0 auto;
  transform: ${({ isActive }) => (isActive ? "translateX(var(--travel))" : "translateX(0)")};
  transition: transform 0.2s ease;
`;

const ToggleSwitch = ({ isActive, setIsActive, inactiveColor, activeColor }) => {
  return (
    <ToggleSwitchButton onClick={setIsActive} isActive={isActive} inactiveColor={inactiveColor} activeColor={activeColor}>
      <Ball isActive={isActive}></Ball>
    </ToggleSwitchButton>
  );
};

export default ToggleSwitch;
